import React, { useState } from "react";
import { Form, Input, Button, Typography, message } from "antd";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { MakeApiCall } from "../../../apis";

const { Title, Text } = Typography;

const WrapperForgot = styled.div`
  background-color: #f1d5d9;
  .ant-input-affix-wrapper .ant-input-suffix {
    position: absolute;
    right: 20px;
    top: 20px;
  }
  .ant-input-affix-wrapper .ant-input {
    font-size: 1.1rem;
    font-weight: 500;
    line-height: 2.5;
  }
  .ant-input-affix-wrapper .ant-input::placeholder {
    color: #a1a5b7;
  }
  .ant-form-item .ant-form-item-explain-error {
    color: var(--bs-danger-text);
    font-size: 0.95rem;
    margin-top: 0.5rem;
  }
`;

export default function ForgotPassword() {
    const [submitLoading, setSubmitLoading] = useState(false);

    const onFinish = async (values) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailRegex.test(values.email)) {
            message.error("Please enter a valid email address");
            return;
        }

        setSubmitLoading(true);
        try {
            const response = await MakeApiCall("forgot-password", "post", {
                email: values.email,
            });

            if (response?.status) {
                message.success(`Reset link sent to ${values.email}`);
            } else {
                message.error(response?.message || "Failed to send reset link");
            }
        } catch (err) {
            message.error("Something went wrong.");
        }
        setSubmitLoading(false);
    };

    return (
        <WrapperForgot className="h-100">
            <div
                className="d-flex flex-column flex-lg-row flex-column-fluid h-100"
                style={{
                    backgroundImage: "url(assets/media/aerial-view-business-team.jpg)",
                    backgroundSize: "cover",
                }}
            >
                {/* Left Side: Form */}
                <div className="d-flex flex-column flex-lg-row-fluid w-lg-40 p-10 order-2 order-lg-1 bg-white m-8" style={{ borderRadius: 20 }}>
                    <div className="d-flex flex-center flex-column flex-lg-row-fluid">
                        <div className="w-lg-500px p-10 px-15 pt-0">
                            {/*<a href="/" className="mb-0 mb-lg-5 d-flex text-start">*/}
                            {/*    <img alt="Logo" src="assets/media/SellerViewLogo.png" className="w-150px ms-n7" />*/}
                            {/*</a>*/}
                            <a href="/" className="mb-0 mb-lg-5 d-flex text-start">
                                <img alt="Logo" src="assets/media/SellerViewLogo.png" className="w-250px ms-n7"/>
                            </a>

                            <Form
                                name="forgot-password"
                                style={{marginTop: "40px"}}
                                className="form w-100"
                                onFinish={onFinish}
                            >
                                <div className="text-start mb-7">
                                    <h1 className="text-gray-900 fw-bolder mb-3">Forgot Password?</h1>
                                    <div className="text-gray-500 fw-semibold fs-5">
                                        No worries! Enter your email and we’ll send you reset instructions.
                                    </div>
                                </div>

                                <div className="fv-row mb-8">
                                    <Form.Item
                                        name="email"
                                        rules={[{required: true, message: "Please input your email!"}]}
                                    >
                                        <Input
                                            size="large"
                                            className="form-control form-control-solid px-8 h-60px"
                                            placeholder="Email Address"
                                        />
                                    </Form.Item>
                                </div>

                                <div className="d-grid mb-10">
                                    <Button
                                        htmlType="submit"
                                        loading={submitLoading}
                                        className="btn btn-danger h-60px cus-shadow-btn"
                                        block
                                    >
                    <span className="indicator-label d-flex justify-content-center">
                      Send Reset Link
                      <i className="ki-outline ms-2 ki-arrow-right fs-1"/>
                    </span>
                                    </Button>
                                </div>

                                <div className="text-gray-500 text-start fw-semibold fs-5">
                                    Remembered your password?
                                    <Link to="/login" className="link-primary"> Sign in</Link>
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>

                {/* Right Side: Image */}
                <div
                    className="d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2 position-relative"
                    style={{
                        backgroundImage: "url(assets/media/misc/auth-bg.png)",
                        background: "#F1D5D9",
                        backdropFilter: "blur(6px)",
                    }}
                >
                    <div className="d-flex flex-column flex-center py-7 py-lg-15 px-5 px-md-15 w-100">
                        <img
                            className="d-none d-lg-block mx-auto w-275px w-md-50 w-xl-500px mb-10"
                            src="assets/media/forgot-password.png"
                            alt="Forgot Password Illustration"
                        />
                    </div>
                </div>
            </div>
        </WrapperForgot>
    );
}